import React from "react";
import { firebase, database, auth } from '../firebase';
import Alert from './Alert';

class Like extends React.Component {
  constructor(props) {
    super(props);
    this.database = database.ref(`likes/${window.location.pathname.slice(2)}`);
    this.user = auth.currentUser;
    this.state = {
      array: [],
      array2: [],
      onLiked: false,
      likeCount: 0,
      open: false,
    };
    this.dark = this.dark.bind(this);
    this.yap = this.yap.bind(this);
  }

  componentWillMount() {
    auth.onAuthStateChanged(user => {
      const userID = auth.currentUser !== null ? auth.currentUser.uid : "a";
      const likeSayısı = this.state.array;
      const myLike = this.state.array2;

      this.database.on('child_added', snap => {
        if (snap.val().id === userID) myLike.push({ data: snap.val() });
        if (snap.val().liked === true) likeSayısı.push({ data: snap.val() });

        this.setState({
          array: likeSayısı,
          array2: myLike,
          likeCount: likeSayısı.length,
          onLiked: myLike[0] && myLike[0].data.liked, // update the like status
        });
      });

      this.database.on('child_removed', snap => {
        const index = likeSayısı.findIndex(like => like.data.id === snap.key);
        if (index !== -1) {
          likeSayısı.splice(index, 1);
        }
        this.setState({
          array: likeSayısı,
          array2: myLike,
          likeCount: likeSayısı.length,
        });
      });
    });
  }

  dark() {
    if (auth.currentUser === null) return this.yap();

    const { onLiked, likeCount } = this.state;
    if (!onLiked) {
      this.setState({
        onLiked: true,
        likeCount: likeCount + 1,
      });

      this.database.child(firebase.auth().currentUser.uid).set({
        id: firebase.auth().currentUser.uid,
        liked: true,
      });

      database.ref(`posts/${window.location.pathname.slice(2)}`).get().then((snap) => {
        const postId = window.location.pathname.slice(2);
        const postAuthor = snap.val().postAuthor;
        
        if (auth.currentUser.uid !== postAuthor) {
          // Query for existing notifications with the same type, post, and author
          database.ref("notifications/" + postAuthor)
            .orderByChild('post')
            .equalTo(postId)  // Make sure to filter by post
            .once('value', (snapshot) => {
              let exists = false;
              snapshot.forEach((childSnapshot) => {
                const notification = childSnapshot.val();
                // Check if the notification has the same type and author
                if (notification.type === "like" && notification.author === auth.currentUser.uid) {
                  exists = true;
                }
              });
  
              if (!exists) {  // If no such notification exists, create one
                database.ref("notifications/" + postAuthor).push().set({
                  author: auth.currentUser.uid,
                  date: Date.now(),
                  okundu: false,
                  post: postId,
                  type: "like",
                });
              }
            });
        }
      });
    } else {
      this.setState({
        onLiked: false,
        likeCount: likeCount - 1,
      });

      this.database.child(firebase.auth().currentUser.uid).set({
        id: firebase.auth().currentUser.uid,
        liked: false,
      });
    }
  }

  copy() {
    const copyText = document.getElementById("myInput");
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    document.execCommand("copy");
    alert("Kopyalandı!");
  }

  yap() {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  }

  render() {
    const { likeCount, onLiked, open } = this.state;
    const likeImageSrc = onLiked ? "/liked.png" : "/like.png";

    return (
      <div id="labıl" className="labıl" onClick={this.yap}>
        {auth.currentUser == null ? (
          <Alert
            baslik="Üzgünüm!"
            content="Bunun için giriş yapman gerekli!"
            onay="Beni Oraya Götür!"
            onayLink="/giris-yap"
            red="Anlıyorum..."
            opened={open}
          />
        ) : (
          ""
        )}
        <div className="tooltip2">
          <span className="tooltiptext2">Beğen</span>
          <div>
            <a id="likeCount" className="likeCount">
              {likeCount}
            </a>
            <img
              id="iy"
              className="iy"
              src={likeImageSrc}
              onClick={this.dark}
              alt="Like"
            />
          </div>
        </div>
        <div style={{ cursor: "pointer" }}>
          <div className="tooltip">
            <span className="tooltiptext">Yazı Bağlantısını Kopyala</span>
            <img
              src="/link.png"
              className="link"
              onClick={this.copy}
              alt="Copy Link"
            />
          </div>
          <input
            type="text"
            value={window.location.href}
            id="myInput"
            style={{ position: "fixed", marginTop: "-123412341234px" }}
            readOnly
          />
        </div>

        <style>{`
        .labıl {
          width: auto;
          height: auto;
          position: absolute;
          background-size: cover;
          padding: 0 15px;
        }

        .link {
          top: -15px;
          width: 22px;
          height: 22px;
          position: absolute;
          margin-left: 20px;
          padding: 3px;
          background: #ccc;
          border-radius: 100%;
        }

        .iy {
          position: relative;
          top: 26px;
          margin-left: 0px;
          width: 20px;
          height: 18px;
          cursor: pointer;
        }

        .likeCount {
          margin-right: 2px;
          top: 22px;
          position: relative;
          cursor: pointer;
        }

        .tooltip {
          position: relative;
          display: inline-block;
        }
        
        .tooltip .tooltiptext {
          visibility: hidden;
          width: 140px;
          background-color: #2f2d33;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          padding-bottom: 10px;
          position: absolute;
          z-index: 1;
          bottom: 25px;
          left: 50%;
          margin-left: -41px;
          opacity: 0;
          transition: opacity 0.3s;
        }
        
        .tooltip .tooltiptext::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #2f2d33 transparent transparent transparent;
        }
        
        .tooltip:hover .tooltiptext {
          visibility: visible;
          opacity: 1;
        }

        .tooltip2 {
          position: relative;
          display: inline-block;
        }
        
        .tooltip2 .tooltiptext2 {
          visibility: hidden;
          width: 60px;
          background-color: #2f2d33;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          padding-bottom: 10px;
          position: absolute;
          z-index: 1;
          bottom: 5px;
          left: 0%;
          margin-left: -14px;
          opacity: 0;
          transition: opacity 0.3s;
        }
        
        .tooltip2 .tooltiptext2::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #2f2d33 transparent transparent transparent;
        }
        
        .tooltip2:hover .tooltiptext2 {
          visibility: visible;
          opacity: 1;
        }
    `}</style>
      </div>
    )
  }
};

export default Like;